module.exports = __webpack_public_path__ + "02_glasses_black.75c95343.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/02_glasses_black.png
// module id = Ah/x
// module chunks = 0